<div class="content">
  <div class="header">
    <app-navbar></app-navbar>
  </div>
  <div class="wrapper">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
